(function () {
  'use strict';

  angular
    .module('app.form', ['thatisuday.dropzone'])

    /* @ngInject */
    .factory('FormService', ["HttpService", "AppService", "ModalService", function (HttpService, AppService, ModalService) {
      return {
        emailChanged: function (ctrl) {
          if (ctrl.form.Email.$valid) {
            AppService.getParams()
              .then(function (params) {
                if (!params.IsLogged) {
                  HttpService.post({
                    url: '/TestMailExist',
                    data: {
                      Email: ctrl.formData.Email
                    }
                  })
                  .then(function (response) {
                    if (response.status === 'ERROR') {
                      for (var fieldName in response.errors) {
                        if (fieldName === 'Global' && response.errors[fieldName].Errors[0].ErrorMessage === 'AccountExist') {
                          ModalService.show(
                            '/Template/Authentication/ModalAuthentication',
                            {
                              mailRecognized: ctrl.formData.Email
                            },
                            null,
                            'loginModalCtrl'
                          );
                        }
                      }
                    }
                  })
                  .catch(function (error) {
                    console.error(error);
                  });
                }
              });
          }
        }
      };
    }])

    /* @ngInject */
    .controller('ContactController', ["$scope", "$timeout", "HttpService", "AppService", "FormService", "smoothScroll", "RoutesService", function ($scope, $timeout, HttpService, AppService, FormService, smoothScroll, RoutesService) {
      var ctrl = this,
        unwatch;

      ctrl.formData = {
        Attachments: [],
        errors: {}
      };

      $scope.$on('$destroy', function () {
        if (typeof unwatch !== 'undefined') {
          unwatch();
        }
      });

      ctrl.focus = function () {
        ctrl.formData.errors.Global = null;
      };

      ctrl.init = function (object) {
        ctrl.formData.CustomerPro = object.CustomerPro === 'True' ? true : false;

        unwatch = $scope.$watch('accountCtrl.formData.CustomerPro', function (value) {
          if (!value) {
            ctrl.formData.IDCompanyTitle = '';
            ctrl.formData.Company = '';
            $timeout(function () {
              $('#IDCompanyTitle').selectpicker('val', '');
            });
          }
        });
      };

      ctrl.dzOptions = {
        paramName: 'files',
        acceptedFiles: 'image/jpeg, images/jpg, image/png, image/gif, .pdf, .doc, .docx, .xls, .xlsx, .zip',
        uploadMultiple: true,
        renameFilename: function (name) {
          return new Date().getTime() + '_!_' + name;
        }
      };

      ctrl.dzCallbacks = {
        successmultiple: function (files) {
          _.each(files, function (file) {
            ctrl.formData.Attachments.push({
              Name: file.name,
              ServerName: file.serverName
            });
          });
        },
        removedfile: function (file) {
          _.remove(ctrl.formData.Attachments, { Name: file.Name });
        }
      };

      ctrl.emailChanged = function () {
        FormService.emailChanged(ctrl);
      };

      ctrl.submit = function () {

        $scope.$emit('showPageLoader', true);

        ctrl.formData.errors = {};

        _.replace(ctrl.formData.Phone, / /g, '');
        _.replace(ctrl.formData.MobilePhone, / /g, '');

        HttpService.post({
          url: '/' + RoutesService.getUrlByName('Contact'),
          data: ctrl.formData
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                smoothScroll(document.body);
                ctrl.messageSent = true;
                $timeout(function () {
                  ctrl.messageSentOK = true;
                }, 350);
              } else {
                _.each(response.errors, function (error, key) {
                  if (key === 'Global') {
                    ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                  }
                });
              }
              $scope.$emit('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

      ctrl.toggleCustomerPro = function (event) {
        if (event.which === 13) {
          event.preventDefault();
          ctrl.formData.CustomerPro = !ctrl.formData.CustomerPro;
        }
      };

    }])

    /* @ngInject */
    .controller('CatalogRequestController', ["$scope", "$timeout", "HttpService", "AppService", "FormService", "smoothScroll", "RoutesService", function ($scope, $timeout, HttpService, AppService, FormService, smoothScroll, RoutesService) {
      var ctrl = this,
        unwatch;

      ctrl.formData = {
        errors: {}
      };

      $scope.$on('$destroy', function () {
        if (typeof unwatch !== 'undefined') {
          unwatch();
        }
      });

      ctrl.focus = function () {
        ctrl.formData.errors.Global = null;
      };

      ctrl.init = function (object) {
        ctrl.formData.CustomerPro = object.CustomerPro === 'True' ? true : false;

        unwatch = $scope.$watch('accountCtrl.formData.CustomerPro', function (value) {
          if (!value) {
            ctrl.formData.IDCompanyTitle = '';
            ctrl.formData.Company = '';
            $timeout(function () {
              $('#IDCompanyTitle').selectpicker('val', '');
            });
          }
        });
      };

      ctrl.emailChanged = function () {
        FormService.emailChanged(ctrl);
      };

      ctrl.submit = function (event) {
        event.preventDefault();

        $scope.$emit('showPageLoader', true);

        _.replace(ctrl.formData.Phone, / /g, '');
        _.replace(ctrl.formData.MobilePhone, / /g, '');

        ctrl.formData.errors = {};

        HttpService.post({
          url: '/' + RoutesService.getUrlByName('CatalogRequest'),
          data: ctrl.formData
        })
        .then(function (response) {
          AppService.getTranslate()
            .then(function (translate) {
              if (response.status === 'OK') {
                smoothScroll(document.body);
                ctrl.messageSent = true;
                $timeout(function () {
                  ctrl.messageSentOK = true;
                }, 350);
              } else {
                _.each(response.errors, function (error, key) {
                  if (key === 'Global') {
                    ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                  }
                });
              }
              $scope.$emit('showPageLoader', false);
            })
            .catch(function (error) {
              console.error(error);
            });
        })
        .catch(function (error) {
          console.error(error);
        });
      };

      ctrl.toggleCustomerPro = function (event) {
        if (event.which === 13) {
          event.preventDefault();
          ctrl.formData.CustomerPro = !ctrl.formData.CustomerPro;
        }
      };

      }])

    /* @ngInject */
    .controller('QuoteController', ["$scope", "$timeout", "$document", "HttpService", "AppService", "ModalService", "smoothScroll", "RoutesService", function ($scope, $timeout, $document, HttpService, AppService, ModalService, smoothScroll, RoutesService) {

      var ctrl = this,
          unwatch;

      ctrl.formData = {
          Attachments: [],
          errors: {},
      };

      ctrl.focus = function () {
          ctrl.formData.errors.Global = null;
      };

      ctrl.init = function (object) {
          ctrl.formData.CustomerPro = object.CustomerPro == 'True' ? true : false;

          $scope.$watch('accountCtrl.formData.CustomerPro', function (value) {
              if (!value) {
                  ctrl.formData.IDCompanyTitle = '';
                  ctrl.formData.Company = '';
                  $('#IDCompanyTitle').selectpicker('val', '');
              }
          });
      };

      ctrl.dzOptions = {
          paramName: 'files',
          acceptedFiles: 'image/jpeg, images/jpg, image/png, image/gif, .pdf, .doc, .docx, .xls, .xlsx, .zip',
          uploadMultiple: true,
          renameFilename: function (name) {
              return new Date().getTime() + '_!_' + name;
          }
      };

      ctrl.dzCallbacks = {
          successmultiple: function (files, responseText) {
              _.each(files, function (file) {
                  ctrl.formData.Attachments.push({
                      Name: file.name,
                      ServerName: file.serverName
                  });
              });
          },
          removedfile: function (file) {
              _.remove(ctrl.formData.Attachments, { Name: file.Name });
          }
      };

      ctrl.emailChanged = function () {
          FormService.emailChanged(ctrl);
      };

      ctrl.submit = function () {

          $scope.$emit('showPageLoader', true);

          ctrl.formData.errors = {};

          _.replace(ctrl.formData.Phone, / /g, '');
          _.replace(ctrl.formData.MobilePhone, / /g, '');
          ctrl.formData.FolderTypeKey = "DEMANDE DEVIS";
          ctrl.formData.Object = "DEMANDE DEVIS";

          HttpService.post({
              url: '/' + RoutesService.getUrlByName('Contact'),
			  data: ctrl.formData
          })
              .then(function (response) {
                  AppService.getTranslate()
                      .then(function (translate) {
                          if (response.status == 'OK') {
                              smoothScroll(document.body);
                              ctrl.messageSent = true;
                              $timeout(function () {
                                  ctrl.messageSentOK = true;
                              }, 350);
                          } else {
                              _.each(response.errors, function (error, key) {
                                  if (key == "Global") {
                                      ctrl.formData.errors[key] = translate.errors[error.Errors[0].ErrorMessage];
                                  }
                              });
                          }
                          $scope.$emit('showPageLoader', false);
                      })
                      .catch(function (response) {
                          console.error(response);
                      });
              })
              .catch(function (response) {
                  console.error(response);
              });
      };

      ctrl.toggleCustomerPro = function (event) {
          if (event.which == 13) {
              event.preventDefault();
              ctrl.formData.CustomerPro = !ctrl.formData.CustomerPro;
          }
      };

  }]);



})();
